/**
 * Saves a fetched response as a file. The export carries a bearer token, so an
 * `<a href>` cannot fetch it; the response is read as a blob and handed to a
 * temporary link instead (docs/frontend-integration.md 6.5).
 */
export async function saveResponse(res: Response, fallbackName: string): Promise<string> {
  const header = res.headers.get("Content-Disposition") ?? "";
  const name = /filename="?([^";]+)"?/.exec(header)?.[1] ?? fallbackName;
  const url = URL.createObjectURL(await res.blob());
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.rel = "noopener";
    document.body.append(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
  return name;
}
